import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import HeaderBanner from 'Components/landings/HeaderBanner';
import Footer from 'Components/landings/Footer';
import { useServerData } from 'serverDataContext';
import { getCurrentCity } from 'Modules/SearchAddress/selectors';
import { useRequest } from 'swr.config';
import { IProductsGroup } from 'Modules/Shops/types';
import { URL } from 'constants/urlMaps';
import { Helmet } from 'react-helmet';
import { dataForMetaTags } from 'Containers/LandingPages/utils';
import fetchDataOnServer from './index.server';
import PurchaseSteps from 'Components/landings/PurchaseSteps';
import Business from 'Components/landings/Business';
import Delivery from 'Components/landings/Delivery';
import PurchaseNow from 'Components/landings/PurchaseNow';
import GroupsSlider from 'Components/landings/GroupsSlider';
import InterfaceBlock from 'Components/landings/InterfaceBlock';
import SeoLinks from 'Components/landings/SeoLinks';
import SelectionBlock from 'Components/landings/SelectionBlock';
import PickerBlock from 'Components/landings/PickerBlock';
import SelectAddressProvider from 'Components/landings/LandingSearchAddress/SelectAddressProvider';
import SelectAddressModal from 'Components/landings/LandingSearchAddress/SelectAddressModal';
import { useScrollToElement } from 'utils/hooks';
import { useUserAgentContext } from 'utils/userAgent/context';
import MobileApp from 'Components/landings/MobileApp';
import analyticsManager from 'utils/tagManager/manager';
import { EnumEvents, EnumGtagEvents } from 'constants/enums';
import amplitude from 'utils/amplitude';
import { GtagDevices } from 'Components/landings/types';

export const SSR_KEY = 'Main';

const Main: React.FC = () => {
  const city = useSelector(getCurrentCity);
  const [deliveryBlockRef, scrollToDeliveryBlock] = useScrollToElement();
  const { isMobile } = useUserAgentContext();
  const dataFromServer = useServerData(SSR_KEY, [city.id]);

  const { data: groups } = useRequest<IProductsGroup[]>([URL.shops_groups, { city_id: city.id }], {
    initialData: dataFromServer?.groups,
  });

  const { title, content_description, content_title } = dataForMetaTags({ groups, city });

  useEffect(() => {
    analyticsManager.gtag(EnumGtagEvents.SHOW_LANDING);
    amplitude.logEvent(EnumEvents.VIEW_LANDING);
  }, []);

  const gtagDevice = isMobile ? GtagDevices.MOBILE : GtagDevices.DESKTOP;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta content={content_description} name="description" />
        <meta content={content_description} property="og:description" />
        <meta content={content_description} name="twitter:description" />
        <meta content={content_title} name="twitter:title" />
        <meta content={title} name="og:title" />
        <link rel="canonical" href="https://igooods.ru/" />
      </Helmet>
      <SelectAddressProvider>
        <HeaderBanner groups={groups} device={gtagDevice} />
        <InterfaceBlock />
        <PickerBlock onBtnClick={scrollToDeliveryBlock} device={gtagDevice} />
        <SelectionBlock />
        <PurchaseSteps />
        <Delivery ref={deliveryBlockRef} device={gtagDevice} />
        <SelectAddressModal />
        <Business device={gtagDevice} />
        <GroupsSlider groups={groups} />
        <PurchaseNow device={gtagDevice} />
      </SelectAddressProvider>
      <SeoLinks groups={groups} />
      <Footer />
      {true && <MobileApp />}
    </>
  );
};

Main.fetchOnServer = fetchDataOnServer;

export default Main;
